export function Store() {
  return (
    <>
      <svg width="24" height="24px" fill="none">
        <use href="#icon-store"></use>
      </svg>
      <svg width="0" height="0" fill="none">
        <symbol id="icon-store" viewBox="0 0 24 24">
          <g id="tienda">
            <path
              id="Vector"
              d="M19.9243 12V18.8571C19.9243 19.1602 19.8109 19.4509 19.6089 19.6653C19.4069 19.8796 19.133 20 18.8474 20H7.00124C6.71562 20 6.4417 19.8796 6.23974 19.6653C6.03778 19.4509 5.92432 19.1602 5.92432 18.8571V12"
              stroke="#2E8241"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              id="Vector_2"
              d="M19.4296 4H6.41907C6.29768 3.99998 6.17991 4.03873 6.08516 4.10987C5.99041 4.181 5.92434 4.28028 5.89783 4.39133L4.92432 8.5C4.92432 8.89783 5.09289 9.27936 5.39295 9.56066C5.693 9.84196 6.09997 10 6.52432 10C6.94866 10 7.35563 9.84196 7.65569 9.56066C7.95575 9.27936 8.12432 8.89783 8.12432 8.5C8.12432 8.89783 8.29289 9.27936 8.59295 9.56066C8.893 9.84196 9.29997 10 9.72432 10C10.1487 10 10.5556 9.84196 10.8557 9.56066C11.1557 9.27936 11.3243 8.89783 11.3243 8.5C11.3243 8.89783 11.4929 9.27936 11.7929 9.56066C12.093 9.84196 12.5 10 12.9243 10C13.3487 10 13.7556 9.84196 14.0557 9.56066C14.3557 9.27936 14.5243 8.89783 14.5243 8.5C14.5243 8.89783 14.6929 9.27936 14.9929 9.56066C15.293 9.84196 15.7 10 16.1243 10C16.5487 10 16.9556 9.84196 17.2557 9.56066C17.5557 9.27936 17.7243 8.89783 17.7243 8.5C17.7243 8.89783 17.8929 9.27936 18.1929 9.56066C18.493 9.84196 18.9 10 19.3243 10C19.7487 10 20.1556 9.84196 20.4557 9.56066C20.7557 9.27936 20.9243 8.89783 20.9243 8.5L19.9501 4.39133C19.9239 4.28028 19.8579 4.18095 19.7633 4.10978C19.6686 4.03862 19.5509 3.99989 19.4296 4Z"
              stroke="#2E8241"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              id="Vector_3"
              d="M5.92432 16H14.9243"
              stroke="#2E8241"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              id="Vector_4"
              d="M14.9243 20V12"
              stroke="#2E8241"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </g>
        </symbol>
      </svg>
    </>
  );
}
